/* eslint-disable react/no-array-index-key */
import React from "react";
import { GroupProps } from "./GroupProps";
import FilterGroup from "./FilterGroup";
const VendorFilter = ({
  groups,
  toggleCollapsed,
  groupsWithMultipleSelections,
  prefetch
}: GroupProps) => {
  return <>
      {groups.map(group => <FilterGroup key={`vendorFilter-${group.groupNameEncoded}`} group={group} toggleCollapsed={toggleCollapsed} groupsWithMultipleSelections={groupsWithMultipleSelections} data-test="VendorFilter" filterText="vendor" prefetch={prefetch} />)}
    </>;
};
export default VendorFilter;